import React, { useEffect, useState } from "react";
import { MessageCircle, ShieldCheck } from "lucide-react";
import { api } from "../../lib/api";
import { useInboxSocket } from "../../lib/useInboxSocket";
import MessageThread from "../../components/MessageThread";

/** Customer single-thread inbox — appears as a conversation with HouseDesignWala. */
export default function CustomerInbox() {
  const [conv, setConv] = useState(null);
  const { liveMessage, connected, liveTyping, sendTyping } = useInboxSocket(true);

  useEffect(() => {
    api.get("/inbox").then(r => setConv(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl font-bold text-[#1a3c5e]" data-testid="customer-inbox-title">Messages</h2>
        <div className="text-xs text-gray-500 flex items-center gap-1.5">
          <span className={`w-2 h-2 rounded-full ${connected ? "bg-emerald-500" : "bg-amber-400"}`} />
          {connected ? "Live" : "Reconnecting..."}
        </div>
      </div>
      <div className="bg-emerald-50/70 border border-emerald-200 rounded-2xl p-4 flex items-start gap-3" data-testid="customer-privacy-banner">
        <ShieldCheck className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-emerald-900">
          You're chatting with HouseDesignWala. Your assigned designer replies through us to keep your details safe and ensure quality control.
        </div>
      </div>
      <div className="h-[68vh]">
        <MessageThread
          conversationId={conv?.id}
          role="customer"
          apiBase="/inbox"
          liveMessage={liveMessage}
          liveTyping={liveTyping}
          sendTyping={sendTyping}
          header={
            <div className="px-4 py-3 border-b border-gray-100 bg-white flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#1a3c5e] to-[#F7941D] text-white flex items-center justify-center">
                <MessageCircle className="w-5 h-5" />
              </div>
              <div>
                <div className="font-display font-bold text-[#1a3c5e]" data-testid="customer-inbox-counterparty">HouseDesignWala Support</div>
                <div className="text-[11px] text-emerald-700">● Online · Replies usually within 30 min</div>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
}
